import {createSelector} from '@reduxjs/toolkit'

const additionalBranchQuestionSelector = createSelector(
    [state => state.components],
    ({additionalBranchQuestion}) => {
        return Object.assign({},additionalBranchQuestion)
    }
)

export const additionalBranchQuestionSelect = state => ({
    additionalBranchQuestion: additionalBranchQuestionSelector(state)
})

const additionalBranchDetailsSelector = createSelector(
    [state => state.components,
        state => state.primaryAgencyApplication.application,
        state => state.additionalApplications.additionalBranchApplications],
    ({additionalBranchDetails},primaryApplication,additionalBranchApplications) => {

        let additionalBranches = []
        
        additionalBranchApplications.forEach(branchApp => {
            // branch status will be marked EXPIRED if not selected for renewal
            if(!branchApp.markedDoNotRenew && !branchApp.markedDeleted)
            {
                if(branchApp.businessLicenceData && 
                    branchApp.businessLicenceData.additionalBranches && 
                    Array.isArray(branchApp.businessLicenceData.additionalBranches))
                {
                    branchApp.businessLicenceData.additionalBranches.forEach(branch => {
                        additionalBranches.push({
                            ...branch, 
                            id : branchApp.id
                        })
                    })
                }
            }
            
        });

        return Object.assign({},
            additionalBranchDetails,
            {primaryApplication},
            {additionalBranches})
    }
)

export const additionalBranchDetailsSelect = state => ({
    additionalBranchDetails: additionalBranchDetailsSelector(state)
})

export function populateAdditionalBranchesData(additionalBranches) {
    if(additionalBranches) {
        return additionalBranches.map((branch) => ({
            "Branch Name" : branch.branchName,
            "Branch street" : branch.address.street,
            "Branch city/town" : branch.address.city,
            "Branch postal code" : branch.address.postalCode,
            "Responsible agent" : branch.manager.firstName,
            "Phone" : branch.manager.phoneNumber,
            "Email" : branch.manager.emailAddress
        }))
    }

    return []
}

export const currentBranchApplicationSelector = createSelector(
    [state => state.additionalApplications],
    (additionalApplications) => {
        let branchApp = null

        if(additionalApplications?.additionalBranchApplications?.length) {
            if(additionalApplications.currentBranchApplicationId) {
                branchApp = additionalApplications.additionalBranchApplications.find(
                    app => app.id === additionalApplications.currentBranchApplicationId)
            } else if(additionalApplications?.additionalBranchApplications?.length === 1) {
                branchApp = additionalApplications.additionalBranchApplications[0]
            }
        }
        
        return branchApp;
    }
)

export const branchDetailsViewSelect = state => {
    const branchApplication = currentBranchApplicationSelector(state)
    const branches = branchApplication?.businessLicenceData?.additionalBranches;
    let branchReviewData = null;
    if(branches && Array.isArray(branches)) {
        const branchReviews = populateAdditionalBranchesData(branches);
        branchReviewData = branchReviews[0];
    }

    return {
        currentBranchApplication: branchApplication,
        currentBranchReviewData: branchReviewData
    }
}
